import { tss } from 'tss-react/mui';

export const useNoAgentNotificationStyles = tss.create(({ theme }) => ({
  notification: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(3),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
}));
